<template>
    <Modal :show="show" role="alertdialog" size="lg">
        <form
            @submit.prevent="handleConfirm"
            class="mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden"
            style="width: 460px"
        >
            <slot>
                <div class="px-8 pt-8 pb-2">
                    <Heading class="mb-6">{{
                            __('Re-enter Password')
                        }}</Heading>
                    <p class="text-80 leading-normal">
                        {{ __('Please Re-Enter Your Password For Access To Special Promotion Feature') }}
                    </p>
                </div>
            </slot>

            <div class="px-8 pb-8">
                <label for="new_password" class="inline-block text-80 pt-2 leading-tight mb-2">Password:
                    <span class="text-danger text-sm"> *</span>
                </label>
                <input
                    id="password"
                    type="text"
                    v-model="password"
                    @input="inputEventForPassword($event)"
                    :class="{ 'border-danger': errors.password }"
                    class="w-full form-control form-input form-input-bordered"
                    autocomplete="off"
                />
                <div v-if="errors.password" class="help-text error-text mt-2 text-red-400">{{ errors.password[0] }}</div>
            </div>

            <div class="bg-gray-100 dark:bg-gray-700 px-6 py-3 flex">
                <div class="ml-auto">
                    <LinkButton
                        type="button"
                        dusk="cancel-button"
                        @click.prevent="handleClose"
                        class="mr-3"
                    >
                        {{ __('Cancel') }}
                    </LinkButton>

                    <button
                        id="confirm-password-button"
                        ref="confirmButton"
                        data-testid="confirm-button"
                        type="submit"
                        class="mr-2 shrink-0 h-9 px-4 focus:outline-none ring-primary-200 dark:ring-gray-600 focus:ring text-white dark:text-gray-800 inline-flex items-center font-bold shadow rounded focus:outline-none ring-primary-200 dark:ring-gray-600 focus:ring bg-primary-500 hover:bg-primary-400 active:bg-primary-600 text-white dark:text-gray-800 inline-flex items-center font-bold px-4 h-9 text-sm mr-2 shrink-0 h-9 px-4 focus:outline-none ring-primary-200 dark:ring-gray-600 focus:ring text-white dark:text-gray-800 inline-flex items-center font-bold"
                    >
                        <Loader v-if="working" width="30"></Loader>
                        <span v-else>{{ __('Submit') }}</span>
                    </button>
                </div>
            </div>
        </form>
    </Modal>
</template>

<script>
import Modal from "./Modal.vue";
import Heading from "../Heading.vue";
import Loader from "../Icons/Loader.vue";
export default {
    components: {Loader, Heading, Modal},
    data: () => ({
        password: '',
        originalPassword: '',
        errors: {},
        working: false
    }),
    props: {
        show: {type: Boolean, default: false},
    },
    methods: {
        inputEventForPassword() {
            const value = event.target.value;
            // if (!value.includes('*')) {
            //   this.originalPassword = value;
            // } else {
            const cursorPosition = event.target.selectionStart; // Get the cursor position
            if (value.length === 0) {
                // If the length of the value has decreased
                this.originalPassword = '';
            } else if (value.length < this.originalPassword.length) {
                // If the length of the value has decreased
                const deletedChar = this.originalPassword.charAt(cursorPosition); // Get the deleted character
                const deletedCharIndex = this.originalPassword.indexOf(deletedChar); // Get the index of the deleted character
                this.originalPassword = this.originalPassword.slice(0, deletedCharIndex) + this.originalPassword.slice(deletedCharIndex + 1);
            } else {
                // If a character is added
                const addedChar = value.charAt(cursorPosition - 1); // Get the added character
                const addedCharIndex = this.originalPassword.length - (value.length - cursorPosition); // Calculate the index of the added character
                this.originalPassword = this.originalPassword.slice(0, addedCharIndex) + addedChar + this.originalPassword.slice(addedCharIndex);
            }
            // }
            this.password = '*'.repeat(value.length); // Mask the displayed password
        },
        handleClose() {
            this.$emit('close')
        },
        handleConfirm() {
            this.working = true
            const length = 10; // Specify the length of the random string
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const promotionToken = Array.from({length}, () => characters.charAt(Math.floor(Math.random() * characters.length))).join('');
            Nova.request({
                method: 'post',
                url: `/nova-api/promotion/confirm-password`,
                data: {
                    'password' : this.originalPassword,
                    'promotionToken' : promotionToken
                }
            })
                .then(response => {
                    this.$emit('close')
                    this.working = false
                    window.location.href = '/nova/resources/promotions';
                })
                .catch(error => {
                    this.working = false
                    if (error.response.status == 422) {
                        this.errors = error.response.data.errors
                        console.log(this.errors);
                        Nova.error(this.__('There was a problem executing the action.'))
                    }
                })
        },
    },
    /**
     * Mount the component.
     */
    mounted() {
        // this.$refs.confirmButton.focus()
    },
}
</script>
